<template>
    <v-container v-if="universidad" fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex md12>
                <v-card>
                    <v-card-title>
                        <router-link :to="{ name: 'UniversidadSedes', params: { id: universidad.id } }">
                            {{ universidad.universidad }}
                        </router-link>
                        /sedes
                    </v-card-title>
                    <models-sedes-table :items="universidad.sedes"></models-sedes-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import { UniversidadesService } from "../../services/carreras-api.service"

export default {
    data: () => ({
        universidad: null
    }),
    created() {
        UniversidadesService.find(this.$route.params.id, { include: "sedes?:sedeImagenes?" }).then(universidad => {
            this.universidad = universidad
        })
    }
}
</script>
